import * as Yup from 'yup'
import LookupType from './LookupType'


const WarrantyWorkOrderColorAddition = Yup.object().shape({
    id: Yup.number().nullable(),
    warranty_work_order_id: Yup.number().nullable(),

    material_type: LookupType.nullable(),
    price_level: Yup.string().nullable(),
    color: LookupType.nullable(),
    section: LookupType.nullable(),
    addition: LookupType.nullable(),
    spa_code: Yup.string().nullable(),
    pool_code: Yup.string().nullable()
})


export const WarrantyWorkOrderSchema = Yup.object().shape({
    id: Yup.number().nullable(),
    job_id: Yup.number().nullable(),
    job_detail_id: Yup.number().nullable(),
    company: LookupType.nullable(),
    company_supervisor: LookupType.nullable(),
    job_name: Yup.string().nullable(),

    address_line_1: Yup.string().nullable(),
    city: Yup.string().nullable(),
    state: Yup.string().nullable(),
    zip_code: Yup.string().nullable(),
    gate_code: Yup.string().nullable(),

    gunite_date: Yup.string().nullable(),
    plaster_date: Yup.string().nullable(),
    detail_date: Yup.string().nullable(),

    gunite_crew: LookupType.nullable(),
    applicator: Yup.string().nullable(),
    detail_crew: LookupType.nullable(),

    problem_description_and_location: Yup.string().nullable(),
    scheduled_date: Yup.string().nullable(),
    problem_solution_and_work_performed: Yup.string().nullable(),
    date_completed: Yup.string().nullable(),
    tech_completed: Yup.string().nullable(),

    color_additions: Yup.array().of(WarrantyWorkOrderColorAddition).nullable(),
})